// src/app/modules/BulkUpload/constants/validationRules.js

export const FILE_RULES = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_ROWS: 100,
  ALLOWED_EXTENSIONS: ['.xlsx', '.xls'],
  ALLOWED_MIME_TYPES: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ],
};

export const REQUIRED_COLUMNS = [
  'parent1_firstname',
  'parent1_lastname',
  'parent1_email',
  'parent1_phone',
  'parent2_firstname',
  'parent2_lastname',
  'parent2_email',
  'parent2_phone',
  'student_firstname',
  'student_lastname',
  'student_dob',
  'program_start_date',
];